import type { devtools } from 'zustand/middleware';
import { optionalDevtools } from 'zustand-utils';

export const createDevtools =
  (name: string): typeof devtools =>
  (initializer) => {
    let showDevtools = false;

    // check URL to show devtools
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      const debug = url.searchParams.get('debug');
      if (debug?.includes(name)) {
        showDevtools = true;
      }
    }

    // Return the Zustand middleware with optional DevTools enabled
    return optionalDevtools(showDevtools)(initializer, {
      name: `Rubidex_${name}${import.meta.env.DEV ? '_DEV' : ''}`,
    });
  };
